import React from 'react';

export default function DuplicateFilter({
  query,
  folder,
  sort,
  onQueryChange,
  onFolderChange,
  onSortChange,
  onSubmit,
  onBulkCleanup,
  onDeleteAll,
}) {
  return (
    <div className="dup-filter-bar">
      <form
        className="dup-filter-left"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        <div className="dup-search-wrap">
          <svg className="dup-search-icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
            <path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
          <input
            type="search"
            className="dup-filter-input"
            placeholder="Search sender, subject…"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
          />
        </div>
        <select
          className="dup-filter-select"
          value={folder}
          onChange={(e) => onFolderChange(e.target.value)}
        >
          <option value="">All Folders</option>
          <option value="inbox">Inbox</option>
          <option value="sent">Sent</option>
          <option value="spam">Spam</option>
        </select>
        <select
          className="dup-filter-select"
          value={sort}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="newest">Sort by: Newest</option>
          <option value="oldest">Sort by: Oldest</option>
          <option value="size">Sort by: Size</option>
          <option value="count">Sort by: Count</option>
        </select>
        <button type="submit" className="dup-secondary-btn">Search</button>
      </form>

      <div className="dup-filter-right">
        <button type="button" className="dup-chip-btn" onClick={() => onBulkCleanup('keep_newest')}>
          Keep Newest
        </button>
        <button type="button" className="dup-chip-btn" onClick={() => onBulkCleanup('keep_oldest')}>
          Keep Oldest
        </button>
        <button type="button" className="dup-chip-btn" onClick={() => onBulkCleanup('keep_starred')}>
          Keep Starred
        </button>
        <button type="button" className="dup-chip-btn" onClick={() => onBulkCleanup('keep_unread')}>
          Keep Unread
        </button>
        <button type="button" className="dup-delete-all-btn" onClick={onDeleteAll}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
          Delete All Duplicates
        </button>
      </div>
    </div>
  );
}
